<app-spinner [show]="(messageService.loading$ | async)||false" />

<div class="main-content">
  <app-nav-bar class="navbar" />
  <div class="app-container">
    <router-outlet />
  </div>
  <footer>
    <span>
      {{version}}
    </span>
    @if (environmentName  === 'development') {
      <span>
        {{environmentName }}
      </span>
    }
  </footer>
</div>
